import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex w-full animate-pulse" }
const _hoisted_2 = {
  key: 1,
  class: "flex-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.avatar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex-initial mr-4 bg-gray-200 rounded-full", _ctx.avatarSizeClass])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.rows > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "h-4 mt-4 first:mt-0 bg-gray-200 rounded max-w-full",
              style: _normalizeStyle({
          width: _ctx.widths[i - 1],
        })
            }, null, 4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}